var sin;
if (!sin) {
    sin = {};
}

$.extend(sin,
    /**
     * @lends sin
     */
    {
        /**
         * @namesinace
         * @description Header Scroll Function
         */
        gmap: {
            init: function(){
              console.log('init gmap');
                var lat 				= 53.580251,		
                    lng 				= 8.364090,		
                    zoom				= 10,		
                    markericon 	= new google.maps.MarkerImage('img/gmap_marker.png', new google.maps.Size(41, 28)),		
                    mapCenter 	= new google.maps.LatLng(lat,lng),		
                    mapconfig 	= {
                        mapTypeId: 			google.maps.MapTypeId.ROADMAP,
                        center: 			mapCenter,
                        zoom: 				zoom,
                        navigationControl:  true,
                        panControl:			true,
                        scaleControl:		true,
                        mapTypeControl:		true,
                        streetViewControl:	false,
                        scrollwheel: 		false,
                        
                    }, 	
                    map_canvas 	= $('#gmap')[0],		
                    map = new google.maps.Map(map_canvas, mapconfig);
        
                marker = new google.maps.Marker({
                    id: 1,
                    position: new google.maps.LatLng(parseFloat(53.580251), parseFloat(8.364090)),
                    title: 'Schönes im Norden',
                    animation: 2,
                    clickable: false
                });
        
                marker.setMap(map);
            }
        }
    }
);

$(sin.gmap.init);
